export default "__VITE_ASSET__XMWRbjWK__"